import React from 'react';
import { useGlobalCamera } from '@src/core/providers/global-camera-provider';

interface CameraPortalTargetProps {
  style?: React.CSSProperties;
  className?: string;
}

/**
 * Host element where the global camera <video> DOM node is parked.
 * On mount it claims the persistent video; on unmount it returns it to
 * the hidden offscreen host so the WebRTC stream keeps playing without
 * being detached from the DOM tree.
 */
const CameraPortalTarget: React.FC<CameraPortalTargetProps> = ({ style, className }) => {
  const { mountVideoInto, unmountVideoFromTarget } = useGlobalCamera();
  const targetRef = React.useRef<HTMLDivElement | null>(null);

  React.useLayoutEffect(() => {
    const el = targetRef.current;
    if (!el) return;
    mountVideoInto(el);
    return () => {
      unmountVideoFromTarget(el);
    };
  }, [mountVideoInto, unmountVideoFromTarget]);

  return (
    <div
      ref={targetRef}
      className={className}
      style={{ width: '100%', height: '100%', overflow: 'hidden', ...style }}
    />
  );
};

export default CameraPortalTarget;
